module.exports = __webpack_public_path__ + "static/media/mapa-completo.cc7c8067.svg";